import { api_update_follow_entity_path, api_update_follow_identity_path } from '../../routes';
import { SuccessResponse } from '../interfaces';
import request from './request';

export enum FollowAction {
  Follow = 'follow',
  Unfollow = 'unfollow',
}

export enum FollowType {
  Entity = 'entity',
  Identity = 'identity',
}

export interface UpdateFollowArgs {
  followeeId: number;
  followAction: FollowAction;
}

export async function updateFollowEntity({
  followeeId,
  followAction,
}: UpdateFollowArgs): Promise<SuccessResponse> {
  const resp = await request(
    'post',
    api_update_follow_entity_path({ entity_id: followeeId, follow_choice: followAction })
  );
  return resp;
}

export async function updateFollowIdentity({
  followeeId,
  followAction,
}: UpdateFollowArgs): Promise<SuccessResponse> {
  const resp = await request(
    'post',
    api_update_follow_identity_path({
      identity_id: followeeId,
      follow_choice: followAction,
    })
  );
  return resp;
}
